import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { LoadingButton } from '@mui/lab';
import Grid from '@mui/material/Grid';

export default function AlertDialog({ open, handleClose, setReportData, reportData, searchReport, loading }) {
  const formatDateForInput = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (!open) return;

    const today = new Date();
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    setReportData({
      startDate: oneMonthAgo,
      endDate: today,
    });
  }, [open, setReportData]);

  const handleStartDateChange = (date) => {
    setReportData({ ...reportData, startDate: date });
  };

  const handleEndDateChange = (date) => {
    setReportData({ ...reportData, endDate: date });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          width: { xs: '90%', sm: '500px', md: '600px' },
          maxWidth: '600px',
          height: 'max-content',
          borderRadius: '20px',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '20px' }}>
        <Typography variant="h4" sx={{ color: 'text.titles' }}>
          Export Report
        </Typography>
        <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
      </Box>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Start Date"
                type="date"
                value={formatDateForInput(reportData?.startDate)}
                fullWidth
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => handleStartDateChange(new Date(e.target.value))}
                sx={{
                  '& .MuiInputBase-root': {
                    height: '40px',
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="End Date"
                type="date"
                value={formatDateForInput(reportData?.endDate)}
                fullWidth
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => handleEndDateChange(new Date(e.target.value))}
                sx={{
                  '& .MuiInputBase-root': {
                    height: '40px',
                  },
                }}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
            <LoadingButton
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              disabled={loading}
              sx={{ width: '120px', height: '40px' }}
            >
              Cancel
            </LoadingButton>
            <LoadingButton
              variant="contained"
              loading={loading}
              color="main"
              onClick={searchReport}
              sx={{ width: '120px', height: '40px' }}
            >
              Download
            </LoadingButton>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
